import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Rosemount",
  metaDescription: "Professional plumber in Rosemount, MN. Bruce Nelson Plumbing & Heating offers residential and commercial plumbing, heating, and AC services. Call 651-738-9354.",
  heroTitle: "Plumber in Rosemount, MN",
  heroSubtitle: "Trusted plumbing and heating services for Rosemount families.",
  introduction: "Rosemount homeowners trust Bruce Nelson Plumbing & Heating for professional plumbing services. From the established neighborhoods to the growing developments, we serve all of Rosemount with the same commitment to quality that's made us a Twin Cities favorite since 1976. Our technicians are ready to handle any plumbing need.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Full-service plumbing for Rosemount homes and families.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Reliable commercial plumbing for Rosemount businesses.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler installation and repair in Rosemount.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Fast water heater service throughout Rosemount.",
      link: "/services/water-heaters"
    },
    {
      title: "Air Conditioning",
      description: "AC installation and repair to keep Rosemount homes cool.",
      link: "/services/air-conditioning"
    },
    {
      title: "New Construction",
      description: "Plumbing for Rosemount's new home construction.",
      link: "/services/residential"
    }
  ],
  whyChooseUs: [
    "Nearly 50 years serving the south metro",
    "Licensed, bonded, and fully insured",
    "Experience with Rosemount's growing community",
    "Fair, upfront pricing always",
    "Fast response to all Rosemount areas",
    "Highly rated by Rosemount families"
  ],
  serviceAreas: [
    { name: "Eagan", link: "/plumber-eagan" },
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Minneapolis", link: "/plumber-minneapolis" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Newport", link: "/plumber-newport" },
    { name: "Cottage Grove", link: "/plumber-cottage-grove" }
  ],
  testimonial: {
    text: "Excellent work on our new bathroom. BNPH's team was professional, clean, and did a fantastic job. Best plumber in Rosemount!",
    author: "Steve & Amy K."
  }
};

const RosemountPage = () => <CityPageTemplate cityData={cityData} />;

export default RosemountPage;
